import React from 'react';
import Tag from 'antd/lib/tag';

export const ActivityTag = ({ isActive }: { isActive: boolean }) => {
    return isActive ? <Tag color="green">Active</Tag> : <Tag color="volcano">Inactive</Tag>;
};
